import React from 'react';

const Review = ({ review }) => {
    const { name, img, body, rating } = review;
    return (
        <div className='col-lg-4 mt-3'>
            <div className='shadow-lg p-3 h-100'>
                <img src={img} className='rounded-circle' width={100} height={100} alt="" />
                <h3>{name}</h3>
                <h4 className='text-warning fw-bold fs-5'>{rating}</h4>
                <p>{body}</p>
            </div>
        </div>


    );
};

export default Review;